define('kitlCreateEditLayoutView',[
  'module',
  'marionette',
  'backbone',
  'dialogFormView',
  'template!kitlCreateEditLayoutTpl',
  'savingBehavior',
  'bootbox',
  'underscore',
  'app',
  'moment'
], function(
  module,
  Marionette,
  Backbone,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  bootbox,
  _,
  App,
  moment
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      expDt: '.date-expdt',
      prodDt: '.date-proddt'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm'
    },

    regions: {
    },

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
    ],

    initialize: function(options) {
      this.model = options.kitlModel.clone();
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.expDt = moment(this.model.get('expDt')).format('DD-MM-YYYY');
      templateData.prodDt = moment(this.model.get('prodDt')).format('DD-MM-YYYY');
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function() {
      $.material.init();
      this.triggerMethod('enable:cancel:confirm');
    },

    onRender: function() {
      this.initDatePicker(this.ui.expDt, 'expDt');
      this.initDatePicker(this.ui.prodDt, 'prodDt');
    },

    onConfirm: function() {
      if(this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    onSave: function(model) {
      var modelJSON = model.toJSON();
      this.options.kitlModel.set(modelJSON);
      this.triggerMethod('saved');
      App.navigate('admin/kits/' + model.get('refKit').secId + '/kitl', {trigger: true});
      this.hide();
    },

    hide: function() {
      var kitSecId = this.model.get('refKit')?this.model.get('refKit').secId:'';
      var secId = this.model.get('secId');
      this.triggerMethod('hide');
      this.box.modal('hide');
      this.destroy();
      if (App.getCurrentRoute() ===  'admin/kits/'+kitSecId+'/kitl/new' ||
          App.getCurrentRoute() ===  'admin/kits/'+kitSecId+'/kitl/'+secId+'/edit') {
        App.navigate('admin/kits/'+kitSecId+'/kitl', {trigger: true});
      }
    },

    onSaveError: function(model, response) {
      if(response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    },

    onDuplicateCode: function() {
      this.ui.endUserIdInput.popover('show');
      this.ui.endUserIdInput.addClass('invalid');
      this.ui.endUserIdInput.closest('div[data-field-name=code').addClass('has-error');
    }
  });

  module.exports = CreateEditLayoutView;
});
